/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_TitleInputs */

const es_tyc_definitions_title = /** @type {(inputs: Tyc_Definitions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Definiciones`)
};

const en_tyc_definitions_title = /** @type {(inputs: Tyc_Definitions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Definitions`)
};

/**
* | output |
* | --- |
* | "3. Definitions" |
*
* @param {Tyc_Definitions_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_title = /** @type {((inputs?: Tyc_Definitions_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_title(inputs)
	return en_tyc_definitions_title(inputs)
});
export { tyc_definitions_title as "tyc.definitions.title" }